import { Component, AfterViewInit, OnDestroy, ViewChild, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Rx';

import { IDashBoardAdminChartDetailsWithProvider, IDashBoardAdminChartDetails, ICampaignChart } from './dasboard-admin-chart-details.model';
import { DashBoardAdminService } from './dashboard-admin.service';
import { DashboardFilterModel } from "./dashboard-filter-model";
import { DateHelperService, ClaimsService } from '../core/services';
import { LastUpdateBroadcaster } from '../core/broadcasts/last-updated-broadcaster';

import { ViewsComponent } from './views/views.component';
import { RevenueComponent } from './revenue/revenue.component';
import { DashboardAdminStyleService } from "./dashboard-admin-style.service";
import { UniqueModel } from "./uniques/unique.model";

@Component({
    moduleId: module.id,
    templateUrl: 'dashboard-admin.component.html',
    providers: [DashBoardAdminService]
})

export class DashboardAdminComponent implements OnInit, OnDestroy, AfterViewInit {
    errorMessage: string;
    detailsByProvider: IDashBoardAdminChartDetailsWithProvider;
    detailsByProviderForToday: IDashBoardAdminChartDetailsWithProvider;
    detailsByProviderPeriod: string;
    details: IDashBoardAdminChartDetails;
    detailsForToday: IDashBoardAdminChartDetails;
    detailsPeriod: string;
    campaignDetails: ICampaignChart;
    showProviderBottom: boolean = false;
    uniqueRequestsCount: number = 0;
    showTopSectionOverlay: boolean = true;
    showCampaignOverlay: boolean = true;
    showBottomSectionOverlay: boolean = true;
    private readonly IntervalBetWeenAutoRefresh: number = 5000;
    private topSectionSubscribeAutoRefresh: any;
    private bottomSectionSubscribeAutoRefresh: any;
    private topSectionfiltersters: DashboardFilterModel;
    private bottomSectionfiltersters: DashboardFilterModel;
    public static bxslider: any;
    readonly firstPanelId: string = "firstPanelId";
    readonly secondPanelId: string = "secondPanelId";
    private inXhrProviderForToday: any;
    private inXhrDetailsForToday: any;
    private inXhrProvider: any;
    private inXhrDetails: any;
    private inXhrUniqueRequests: any;
    private inXhrGetCampaigns: any;
    eCpmValue: number = 0;
    uniqueModel: UniqueModel;
    private inXhrGetVersionNumber: any;
    versionNumber: string;

    @ViewChild("revenueByAppChild") revenueComponent: RevenueComponent
    @ViewChild("viewsChild") viewsComponent: ViewsComponent

    constructor(
        private dashBoardAdminService: DashBoardAdminService,
        private dateHelper: DateHelperService,
        private lastUpdateBroadcaster: LastUpdateBroadcaster,
        private claimsService: ClaimsService,
        private dashboardAdminStyleService: DashboardAdminStyleService) {
    }

    ngOnInit() {
        this.inXhrGetVersionNumber = this.dashBoardAdminService.getVersionNumber()
            .subscribe((res: any) => {
                this.versionNumber = res.json();
            }, null, null);
    }

    private getDetailsByProvider(): void {
        if (this.inXhrProvider) {
            this.inXhrProvider.unsubscribe();
        }
        this.inXhrProvider = this.dashBoardAdminService.getDetailsByProvider(this.topSectionfiltersters)
            .subscribe(data => { this.detailsByProvider = data, this.lastUpdateBroadcaster.event.next(true) },
                error => { this.errorMessage = <any>error },
                () => { this.onCompleteGetDetailsByProvider() });
    }

    private getDetailsByProviderForToday(): void {
        if (this.inXhrProviderForToday) {
            this.inXhrProviderForToday.unsubscribe();
        }
        this.inXhrProviderForToday = this.dashBoardAdminService.getDetailsByProviderForToday(this.topSectionfiltersters)
            .subscribe(data => {
                this.detailsByProviderForToday = data;
                this.lastUpdateBroadcaster.event.next(true);
            },
                error => { this.errorMessage = <any>error, this.topSectionUnSubscribeAutoRefresh() });
    }

    private getDetails(): void {
        if (this.inXhrDetails) {
            this.inXhrDetails.unsubscribe();
        }
        this.inXhrDetails = this.dashBoardAdminService.getDetails(this.bottomSectionfiltersters)
            .subscribe(data => { this.details = data; },
                error => { this.errorMessage = <any>error },
                () => { this.onCompleteGetDetails() });
    }

    private getDetailsForToday(): void {
        if (this.inXhrDetailsForToday) {
            this.inXhrDetailsForToday.unsubscribe();
        }
        this.inXhrDetailsForToday = this.dashBoardAdminService.getDetailsForToday(this.bottomSectionfiltersters)
            .subscribe(data => { this.detailsForToday = data },
                error => { this.errorMessage = <any>error, this.bottomSectionUnSubscribeAutoRefresh(); });
    }

    private getCampaigns(): void {
        if (this.inXhrGetCampaigns) {
            this.inXhrGetCampaigns.unsubscribe();
        }
        this.showCampaignOverlay = true;
        this.inXhrGetCampaigns = this.dashBoardAdminService.getCampaignDetails(this.topSectionfiltersters)
            .subscribe(data => this.campaignDetails = data, error => this.errorMessage = <any>error, () => this.showCampaignOverlay = false);
    }

    private getUniqueRequests(): void {
        if (this.inXhrUniqueRequests) {
            this.inXhrUniqueRequests.unsubscribe();
        }
        this.inXhrUniqueRequests = this.dashBoardAdminService.getUniqueRequests(this.topSectionfiltersters.publisherIds)
            .subscribe(data => this.uniqueModel = data, error => this.errorMessage = <any>error, () => { });
    }

    private topSectionSubscribeToAutoRefresh(): void {
        if (this.dateHelper.isToday(this.topSectionfiltersters.endDate))
            this.topSectionSubscribeAutoRefresh = Observable.interval(this.IntervalBetWeenAutoRefresh)
                .subscribe(() => { this.getDetailsByProviderForToday(); this.getUniqueRequests(); });
    }

    private topSectionUnSubscribeAutoRefresh(): void {
        if (this.topSectionSubscribeAutoRefresh) {
            this.topSectionSubscribeAutoRefresh.unsubscribe();
            this.topSectionSubscribeAutoRefresh = undefined;
        }
    }

    private bottomSectionSubscribeToAutoRefresh(): void {
        if (this.dateHelper.isToday(this.bottomSectionfiltersters.endDate))
            this.bottomSectionSubscribeAutoRefresh = Observable.interval(this.IntervalBetWeenAutoRefresh)
                .subscribe(() => { this.getDetailsForToday() });
    }

    private bottomSectionUnSubscribeAutoRefresh(): void {
        if (this.bottomSectionSubscribeAutoRefresh) {
            this.bottomSectionSubscribeAutoRefresh.unsubscribe();
            this.bottomSectionSubscribeAutoRefresh = undefined;
        }
    }

    private onCompleteGetDetailsByProvider(): void {
        this.topSectionSubscribeToAutoRefresh();
        this.showTopSectionOverlay = false;
        let self = this;
        setTimeout(function () {
            self.dashboardAdminStyleService.equalizeTopSectionCards();
        }, 500);
    }

    private onCompleteGetDetails(): void {
        this.showBottomSectionOverlay = false;
        this.bottomSectionSubscribeToAutoRefresh();
        let self = this;
        setTimeout(function () {
            self.dashboardAdminStyleService.initBxSlider();
            self.dashboardAdminStyleService.equalizeBottomSectionCards();
        }, 500);
    }

    private unsubsribeCurrentCalls(): void {
        if (this.inXhrProviderForToday)
            this.inXhrProviderForToday.unsubscribe();
        if (this.inXhrDetailsForToday)
            this.inXhrDetailsForToday.unsubscribe();
        if (this.inXhrProvider)
            this.inXhrProvider.unsubscribe();
        if (this.inXhrDetails)
            this.inXhrDetails.unsubscribe();
        if (this.inXhrUniqueRequests)
            this.inXhrUniqueRequests.unsubscribe();
        if (this.inXhrGetCampaigns)
            this.inXhrGetCampaigns.unsubscribe();
        if (this.inXhrGetVersionNumber)
            this.inXhrGetVersionNumber.unsubscribe();
    }

    ngOnDestroy() {
        this.unsubsribeCurrentCalls();
        this.topSectionUnSubscribeAutoRefresh();
        this.bottomSectionUnSubscribeAutoRefresh();
    }

    ngAfterViewInit() {
        let firstPanelId = '#' + this.firstPanelId;
        let secondPanelId = '#' + this.secondPanelId;
        this.dashboardAdminStyleService.afterViewInit(firstPanelId, secondPanelId, this);
    }

    onChildLoaded() {
        if (this.viewsComponent.totalCompletedViews > 0 && this.revenueComponent.totalEarnings > 0)
            this.eCpmValue = this.revenueComponent.totalEarnings / this.viewsComponent.totalCompletedViews * 1000;
        else
            this.eCpmValue = 0;
    }

    onResize(event) {
        this.dashboardAdminStyleService.equalizeTopSectionCards();
        this.dashboardAdminStyleService.equalizeBottomSectionCards();
        if (!this.showBottomSectionOverlay)
            this.dashboardAdminStyleService.initBxSlider();
    }

    public topSectionFilter(filters: DashboardFilterModel) {
        this.showTopSectionOverlay = true;
        this.topSectionUnSubscribeAutoRefresh();
        this.topSectionfiltersters = filters;
        this.detailsByProviderPeriod = filters.period;
        this.getDetailsByProvider();
        this.getCampaigns();
        this.getUniqueRequests();
    }

    public bottomSectionFilter(filters: DashboardFilterModel) {
        this.showBottomSectionOverlay = true;
        this.bottomSectionUnSubscribeAutoRefresh();
        this.bottomSectionfiltersters = filters;
        this.detailsPeriod = filters.period;
        this.getDetails();
    }
}


// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard-admin.component.ts